import axios from 'axios'
import cloneDeep from 'lodash.clonedeep'
import { localStorage } from 'okeoke.localstorage'

var Locations = function (endpoint, app) {
  this.locationUUID = null
  this.locations = null
  this.locationsUpdateTS = null


  this.callbacks = {
    onLocationsLoaded: {},
    onLocationOpenStateUpdated: {},
    onLocationExtendedPrepTimeUpdated: {},
    onLocationCloudDeviceUpdated: {}
  }

  this.addCallback = (cbName, name, func) => {
    try {
      this.callbacks[cbName][name] = func
    } catch (e) {
      console.error('Invalid callback name', cbName)
    }
  }

  this.removeCallback = (cbName, name) => {
    try {
      delete this.callbacks[cbName][name]
    } catch (e) {
      console.error('Invalid callback name', cbName)
    }
  }

  this.callCallbacks = async (cbName, message) => {
    for (let callback of Object.values(this.callbacks[cbName] || {})) {
      if (typeof callback === 'function') {
        try {
          callback(message)
        } catch (e) {
          console.error(e)
        }
      }
    }
  }

  this.getLocation = (uuid) => {
    for (let location of this.locations || []) {
      if (location.uuid === uuid) {
        return location
      }
    }
    return null
  }

  this.setLocationOpenState = (state) => {
    if (this.locations == null) return
    for (let location of this.locations) {
      if (location.uuid === state.locationUUID) {
        location.openState = { ...state }
        this.callCallbacks('onLocationOpenStateUpdated', { location: cloneDeep(location) })
      }
    }
  }

  this.setLocationCloudDevice = (data) => {
    let { locationUUID, cloudDevice } = data
    if (this.locations == null) return
    for (let location of this.locations) {
      if (location.uuid === locationUUID) {
        location.cloudDevice = { ...cloudDevice }
        this.callCallbacks('onLocationCloudDeviceUpdated', { location: { ...location } })
      }
    }
  }

  this.setLocationExtendedPrepTime = (data) => {
    let { locationUUID, extendedPrepTime } = data
    if (this.locations == null) return
    for (let location of this.locations) {
      if (location.uuid === locationUUID) {
        location.extendedPrepTime = { ...extendedPrepTime }
        this.callCallbacks('onLocationExtendedPrepTimeUpdated', { location: { ...location } })
      }
    }
  }

  this.autoSetLocation = () => {
    if (this.locationUUID == null) {
      this.locationUUID = this.getDefaultLocation()
    }
  }

  this.getDefaultLocation = () => {
    let locationUUID = ''
    for (let location of this.locations) {
      if (location.canOrderFrom === 1) {
        if (location.default === 1) return location.uuid
        locationUUID = location.uuid
      }
    }
    return locationUUID
  }

  this.loadBackupLocations = () => {
    let backup = localStorage.getItem(`okeoke-${app || '0'}-locations`)
    if (backup != null) {
      try {
        this.locations = JSON.parse(backup)
        this.autoSetLocation()
        this.callCallbacks('onLocationsLoaded', { locations: this.locations })
        return this.locations
      } catch (e) {
        return []
      }
    } else {
      return []
    }
  }

  this.getLocations = async (forceRefresh = false, token) => {
    if (this.locations != null && !forceRefresh) return this.locations
    if (!forceRefresh && this.locations != null && this.locationsUpdateTS != null && new Date().getTime() - this.locationsUpdateTS < 1000 * 60 * 1) { // less than 1 minute
      return this.locations
    }
    try {
      const response = await axios.get(endpoint + '/api/v1/location/all', { headers: {'Authorization': 'Bearer ' + token} })
      if (response.data?.success) {
        this.locationsUpdateTS = new Date().getTime()
        localStorage.setItem(`okeoke-${app || '0'}-locations`, JSON.stringify(response.data.data))
        this.locations = response.data.data
        this.autoSetLocation()
        this.callCallbacks('onLocationsLoaded', { locations: this.locations })
        return response.data
      } else {
        return this.loadBackupLocations()
      }
    } catch (error) {
      return this.loadBackupLocations()
    }
  }

  this.getOpenHoursDefault = async (locationUUID, openHoursType) => {
    let params = {
      locationUUID,
      openHoursType
    }
    try {
      let response = await axios.get(endpoint + '/api/v1/location/openHoursDefault', {
        params: params
      })
      if(response.data?.success) {
        localStorage.setItem(`okeoke-${app || '0'}-locations-openHoursDefault`, JSON.stringify(response.data))
      }
      return response.data
    } catch (error) {
      let backup = localStorage.getItem(`okeoke-${app || '0'}-locations-openHoursDefault`)
      if (backup != null) {
        try {
          return JSON.parse(backup)
        } catch (e) {
          return { success: false }
        }
      } else {
        return { success: false }
      }
    }
  }

  this.getOpenHoursDates = async (locationUUID, openHoursType, dates) => {
    try {
      let response = await axios.get(endpoint + '/api/v1/location/openHoursDates', {
        params: {
          locationUUID,
          openHoursType,
          dates
        }
      })
      return response.data
    } catch (error) {
      return []
    }
  }
}

export { Locations }
